export default function () {
  return {
    important_course: null,
    course_groups: null,
    selected_group_courses: null,
    selected_group_list: {},
    showCategory: false
  }
}
